const MIN_MLS_LOOKUP_MS = 1500;

function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function fetchMlsLookup(mls_number) {
    const request = axios.get('/mls-lookup/' + encodeURIComponent(mls_number))
        .then(response => response.data)
        .catch(error => {
            console.log(error);

            return null;
        });

    return Promise.all([request, wait(MIN_MLS_LOOKUP_MS)]).then(([data]) => data);
}
